import Card from "@material-ui/core/Card";
export default Card;